module.exports = __webpack_public_path__ + "static/Montserrat-Regular-9c46095118380d38f12e67c916b427f9.ttf";